import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

export const ButtonGroup = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: ${helpers.spacing.small};

	${mobileMediaQuery(css`
		flex-direction: column;
		align-items: stretch;
	`)}
`
